import { CYCLE_FREQUENCY } from 'domain/shared/newProject';

export const rejectValidation = {
  cycleRejectionReason: {
    type: 'string',
    required: true,
  },
};

export const cycleSettingsValidation = {
  settings: {
    type: 'object',
    required: true,
    properties: {
      cycleActivitySettings: {
        type: 'object',
        required: true,
        properties: {
          changeCycleFrequency: {
            type: 'boolean',
            required: false,
          },
          changeCycleFrequencyReason: {
            type: 'string',
            required: {
              value: true,
              when: {
                '$settings.cycleActivitySettings.changeCycleFrequency': {
                  eq: true,
                },
                '$settings.cycleActivitySettings.cycleFrequency': {
                  eq: CYCLE_FREQUENCY.WEEKLY,
                },
              },
            },
          },
          cycleStartDay: {
            type: 'enum',
            required: true,
          },
          cycleEndDay: {
            type: 'enum',
            required: true,
          },
          planningDay: {
            type: 'enum',
            required: true,
          },
          demoDay: {
            type: 'enum',
            required: true,
          },
        },
      },
    },
  },
};
